export interface OrganizationSaveBarProps {
  isSaving: boolean;
  saveSuccess: boolean;
  disabled?: boolean;
  leadingContent?: React.ReactNode;
  onSave: () => void;
}

export function OrganizationSaveBar({
  isSaving,
  saveSuccess,
  disabled = false,
  leadingContent,
  onSave,
}: OrganizationSaveBarProps) {
  return (
    <div
      data-feedback-clearance
      className="sticky bottom-0 box-border h-[47px] shrink-0 bg-(--bg-white)/95 backdrop-blur border-t border-(--border-subtle) px-6 flex items-center justify-end gap-3"
    >
      {leadingContent && <div>{leadingContent}</div>}
      <button
        type="button"
        onClick={onSave}
        disabled={isSaving || disabled}
        className="px-5 py-2 text-sm font-medium text-white bg-(--brand-navy) rounded-[6px] hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-opacity"
      >
        {isSaving ? "Saving…" : saveSuccess ? "Saved" : "Save Profile"}
      </button>
    </div>
  );
}
